import axios from 'axios';
import { getUrls } from '../../../utils/url';
import { getUserUuidHeaders } from '../../../utils/httpUtils';

const { api } = getUrls();

interface VideoStateChangedPayload {
    classSessionUuid: string;
    meetingId: number;
    userUuid: string;
    sourceZoomId: string;
    videoId: string;
    timestamp: number;
    playing: boolean;
    tabId: string;
    playbackRate: number;
}

export const videoStateChanged = async (payload: VideoStateChangedPayload) => {
    axios.post(`${api}/meeting/${payload.meetingId}/video_state_changed`, {
        data: {
            source_zoom_id: payload.sourceZoomId,
            video_id: payload.videoId,
            class_session_uuid: payload.classSessionUuid,
            timestamp: payload.timestamp,
            tab_id: payload.tabId,
            state: payload.playing ? 1 : 2,
            playback_rate: payload.playbackRate
        }
    }, { headers: getUserUuidHeaders(payload.userUuid) });
};
